import Movies from "src/Component/TV/Movies";
import useClock from "src/Hooks/useClock";
import profiles from "../../../Component/TV/profiles.json";
import { useSelector } from "react-redux";
import store from "src/Reducers/store";
import { useEffect, useState } from "react";
import ProfileAndTime from "src/Component/ProfileAndTime";

import "./index.sass";

interface ScreenProps {
  step: number;
  setStep: (step: number) => void;
  pageId: number;
  bundles: any;
  bundlesPkg: any;
  selectedImage: { image: string; hex: string; border: string };
}

const Screen = ({ step, setStep, pageId, bundles, bundlesPkg, selectedImage }: ScreenProps) => {
  const [bigBundles, setBigBundles] = useState<any>([]);

  const currentUser = useSelector(() => store.getState().appReducer.currentUser);

  const time = useClock();

  const currentProfile = profiles.find((profile) => profile.key === currentUser);

  useEffect(() => {
    const newBundles = bundles.map((bundle: any) => {
      if (bundle.pulse && step >= 2) bundle.pulse = false;
      return bundle;
    });
    setBigBundles(newBundles);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [bundles, step]);

  return (
    <>
      <ProfileAndTime bg={selectedImage.image} time={time} currentProfile={currentProfile} />
      <div className="screen-12-bundle">
        <Movies
          selectedImage={selectedImage}
          size="big"
          className="homepage-movies"
          title="Continue Watching"
          data={bigBundles}
          handleOnClickPulse={() => setStep(2)}
        />
      </div>
      <div className="screen-12-small">
        <Movies size="small" className="homepage-movies" title="Continue Watching" data={bundlesPkg} handleOnClickPulse={() => () => {}} />
      </div>
    </>
  );
};

export default Screen;
